import { CardData } from './carddata';
import 'adyen-cse-js';

declare var require: any;

export class CreditCard {
  public number: string;
  public cvc: string;
  public expiryMonth: string;
  public expiryYear: string;
  public holderName: string;

  public publicKey: string;
  public generationTime: string;

  constructor() {
    this.expiryMonth = '';
    this.expiryYear = '';
  }

  public toString(): string {
    let resp: string = '';

    resp += 'number: xxxx yyyy zzzz aaaa';
    resp += ', cvc: xxx';
    resp += ', expiryMonth: MM';
    resp += ', expiryYear: YYYY';
    resp += ', holderName:' + this.holderName;

    return resp;
  }

  public toCardData(generationTime: string): CardData {
    const cardData: CardData = new CardData();
    cardData.generationtime = generationTime;
    console.log('used generationTime: ' + generationTime);

    cardData.number = this.number;
    cardData.cvc = this.cvc;
    cardData.expiryMonth = this.expiryMonth;
    cardData.expiryYear = this.expiryYear;
    cardData.holderName = this.holderName;

    return cardData;
  }

  public encrypt(publicKey: string, genTime: string): string {
    console.log('encrypt called');
    const adyenEncrypt = require('adyen-cse-js');
    const cseInstance = adyenEncrypt.createEncryption(publicKey, { enableValidations: false });

    const cardData: CardData = this.toCardData(genTime);

    const adyenEncryptedData: string = cseInstance.encrypt(cardData);
    console.log('cardData: ' + cardData.toString());
    console.log('adyenEncryptedData: ' + adyenEncryptedData);

    return adyenEncryptedData as string;
  }

  public toJSON(): string {
    return this.encrypt(this.publicKey, this.generationTime);
  }
}
